import { useScrollReveal } from '@/hooks/useScrollReveal';

const standards = [
  {
    icon: 'ri-shield-check-line',
    title: 'HACCP Certified',
    description: 'All processing centres operate under HACCP protocols — hazard analysis, critical control points, and documented corrective actions at every stage.',
  },
  {
    icon: 'ri-government-line',
    title: 'FSSAI Licensed',
    description: 'Every facility holds a valid FSSAI manufacturing licence. Our SKU labels carry full regulatory compliance markings for wholesale and retail trade.',
  },
  {
    icon: 'ri-qr-scan-line',
    title: 'Batch-Level Traceability',
    description: 'From harvest date to the QR on the final pack — every batch is fully traceable with digital audit trails stored on the Freshhlock platform.',
  },
  {
    icon: 'ri-thermometer-line',
    title: 'Cold Integrity Verified',
    description: 'Temperature logging at intake, during processing, and post-freeze ensures the cold chain is never broken — from processor to buyer.',
  },
  {
    icon: 'ri-file-list-3-line',
    title: 'SKU Spec Lock',
    description: 'Once a SKU spec is defined — cut size, grade, pack weight, pack format — it is locked and cannot be changed without network-level approval.',
  },
  {
    icon: 'ri-microscope-line',
    title: 'Third-Party Lab Testing',
    description: 'Random batch samples are sent to NABL-accredited labs for microbiological and chemical testing. Reports are shared transparently with buyers.',
  },
];

export default function ProcessingStandards() {
  const { ref, revealed } = useScrollReveal();

  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div ref={ref} className={`container-page scroll-reveal ${revealed ? 'revealed' : ''}`}>
        <div className="text-center mb-14 md:mb-20">
          <span className="inline-block text-xs font-semibold text-accent-600 uppercase tracking-widest mb-4">
            Quality & Compliance
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-primary-700 mb-4">
            Standards You Can Audit, Not Just Trust
          </h2>
          <p className="text-foreground-500 max-w-xl mx-auto">
            Every processing centre operates under the same quality framework — verifiable, auditable, and consistent across the network.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {standards.map((item) => (
            <div
              key={item.title}
              className="group flex gap-4 p-5 md:p-6 rounded-xl bg-card-50 border border-card-200 shadow-sm hover:shadow-md hover:border-primary-200 hover:-translate-y-0.5 transition-all duration-300 cursor-pointer card-animate"
            >
              <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600 animate-icon-float icon-hover-pop">
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <div>
                <h4 className="font-heading font-semibold text-primary-700 text-sm mb-1.5">
                  {item.title}
                </h4>
                <p className="text-xs text-foreground-500 leading-relaxed">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}